import CurrentDateContext from '@/context/CurrentDateContext';
import { useContext, useEffect, useState } from 'react';

export const CurrentDateProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const currentDateContext = useContext(CurrentDateContext);

	const [currentDateState, setCurrentDateState] =
		useState<typeof currentDateContext>(currentDateContext);

	// If currentDateLastUpdated is not today, reset currentDate
	useEffect(() => {
		const currentDate = new Date();
		const currentDateLastUpdated = currentDateState.currentDateLastUpdated;
		if (
			currentDate.getDate() !== currentDateLastUpdated.getDate() ||
			currentDate.getMonth() !== currentDateLastUpdated.getMonth() ||
			currentDate.getFullYear() !== currentDateLastUpdated.getFullYear()
		) {
			setCurrentDateState({
				...currentDateState,
				currentDate,
				currentDateLastUpdated: currentDate,
			});
		}
	}, [currentDateState]);

	return (
		<CurrentDateContext.Provider
			value={{
				...currentDateState,
				updateCurrentDate: (date: Date) => {
					setCurrentDateState({
						...currentDateState,
						currentDate: date,
						currentDateLastUpdated: new Date(),
					});
				},
			}}
		>
			{children}
		</CurrentDateContext.Provider>
	);
};
